const getNetWorthOptions = (t) => [
    {
        label: t('liquid_net_worth_choice_1'),
        value: '<1,000,000',
    },
    {
        label: t('liquid_net_worth_choice_2'),
        value: '1,000,000 - 5,000,000',
    },
    {
        label: t('liquid_net_worth_choice_3'),
        value: '5,000,000 - 10,000,000',
    },
    {
        label: t('liquid_net_worth_choice_4'),
        value: '>10,000,000',
    },
];

export default getNetWorthOptions;
